import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Panel } from 'react-bootstrap';
import formatMoney from '../../../../utils/formatMoney';
import { withRouter } from 'react-router-dom';
import { fetchGestionCosto,fetchEquiposLogisticaDetalle,fetchProformas,fetchEquiposCortesia,fetchLogisticaCosto } from '../../../../actions';
import Alert from '../../../../components/Alert';
import AgregarEquiposAdicionales from './AgregarEquiposAdicionales';
import inactivarEquiposCortersia from '../../../../utils/inactivarEquiposCortersia';

const ModalCortesia = props => (
  <div className={`modal in ${props.modalOpenvalue ? 'js-open' : ''}`}  role='dialog'>
    <div className={`modal-dialog ${props.modalSize}`} role='document'>
      <button className='btn btn-sm btn-blue modal-close' onClick={() => props.closeModal()}>Cerrar ventana</button>
      <div className='modal-content'>
        <div className='modal-body'>
          <h2 className='modal-title'>Inactivar Equipo de Cortesia</h2>

          <p className='h6 text-center'>
            Esta Seguro que desea inactivar el equipo de cortseia.
          </p><br/>
        <div className='modal-actions'>
          <button className='btn btn-default' onClick={ props.closeModal}>Cancelar</button>
          <button className='btn btn-primary pull-right' onClick ={() => props.fnInactivarEquipoLogistico()} >Aceptar</button>
        </div>
        </div>
      </div>
    </div>
    </div>
);

const Proforma = props => (
<div className='card card-plain card-lg'>
  <button className='card-lg-title btn-clean' onClick={() => props.selectProforma(props.proforma.numProfVeh)}>
    <h3>Proforma - {props.proforma.numProfVeh}
    {props.proformaSeleccionada === props.proforma.numProfVeh ? <i className='ion-chevron-down ml-3 c-cyan' /> : <i className='ion-chevron-up ml-3 c-cyan' />}
    </h3>
  </button>
  <Panel collapsible expanded={props.proformaSeleccionada === props.proforma.numProfVeh} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0' }}>

      <section className='fdv-section' id='equiposLogistica'>


        <header className='fdv-section-head'>
          <h6 className='fdv-section-title'>Equipos de proforma</h6>
        </header>
        <div className='card card-plain card-lg mb-3'>


          <h6 className='h5 mb-3'>
            <span>
              {props.facturacionListado.map((pedido, id) => (
                props.proforma.numProfVeh === pedido.numProfVeh ? (
                  ' ' + pedido.numPedidoVeh
                ) : null
              ))}
            </span>
          </h6>
          <div className='tableWrapper hidden-xs'>
            <table className='table table-hover'>
              <thead className='table-head'>
                <tr>
                  <th>Cod Equipo</th>
                  <th>Detalle</th>
                  <th>Precio Unit.</th>
                  <th>Cantidad</th>
                  <th>Precio Total</th>
                  <th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                {props.equipoAdicionalLocalList.map((data, id) => (
                  <tr key={id}>
                    <td>{data.codEquipo}</td>
                    <td>{data.descEquipo}</td>
                    <td>{data.precio}</td>
                    <td>{data.cantidad}</td>
                    <td>{data.total}</td>
                    <td>Adicionales Locales</td>
                  </tr>
                ))}
                {props.equipoAdicionalEspecialList.map((data, id) => (
                  <tr key={id}>
                    <td>{data.codEquipo}</td>
                    <td>{data.descEquipo}</td>
                    <td>{data.precio}</td>
                    <td>{data.cantidad}</td>
                    <td>{data.total}</td>
                    <td>Adicionales Especiales</td>
                  </tr>
                ))}
                {props.equipoAdicionalOtroList.map((data, id) => (
                  <tr key={id}>
                    <td>{data.codEquipo}</td>
                    <td>{data.descEquipo}</td>
                    <td>{data.precio}</td>
                    <td>{data.cantidad}</td>
                    <td>{data.total}</td>
                    <td>Otros Equi. Adicionales</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className='visible-xs'>
            <div className='tableMob'>
              <div className='tableMob-mainContent'>
                <div className='tableMob-header'>
                  <h3 className='tableMob-title'>Marcos de ventana cromado - furgoneta</h3>
                </div>
                <ul className='tableMob-content row'>
                  <li className='tableMob-content-item col-xs-6'>
                    <p className='labelInfo'>SKU</p>
                    <p>23234</p>
                  </li>
                  <li className='tableMob-content-item col-xs-6'>
                    <p className='labelInfo'>Precio Unit.</p>
                    <p>$3,234.99</p>
                  </li>
                  <li className='tableMob-content-item col-xs-6'>
                    <p className='labelInfo'>Cantidad</p>
                    <p>4</p>
                  </li>
                  <li className='tableMob-content-item col-xs-6'>
                    <p className='labelInfo'>Precio Total</p>
                    <p>$3,234.99</p>
                  </li>
                </ul>
              </div>
              <div className='tableMob-extraContent collapse' />
            </div>
          </div>
        </div>
        <header className='fdv-section-head'>
          <h6 className='fdv-section-title'>Equipos por gestión de costos</h6>
        </header>
        {console.log('props.pedidosGestionCostos',props.pedidosGestionCostos)}
        {
          props.pedidosGestionCostos.map((pedido, index) => (
          <div key={index} className='card card-plain card-lg mb-3'>
            <h6 className='h5 mb-3'>
              <span className='bold'>N° Pedido </span>
              <span>{pedido}</span>
            </h6>
            <div className='tableWrapper hidden-xs'>
              <table className='table table-hover'>
                <thead className='table-head'>
                  <tr>
                    <th>Datos del Equipo Local</th>
                    <th>Valor Venta</th>
                    <th>Moneda</th>
                  </tr>
                </thead>
                <tbody key={index}>
                {
                  props.logisticaCosto.listadoLogisticaCostos.filter(l => l.numPedidoVeh === pedido)
                  .filter(entry => props.equipoAdicionalList.map(equipo => {return equipo.descEquipo}).indexOf(entry.descripcion)>=0?false:true)
                  .map((logisticaCosto, index) => (
                    <tr key={index} className='as' data-toggle='collapse' data-target='#ps212s' >
                      <td> {logisticaCosto.descripcion} </td>
                      <td> {(logisticaCosto.precioOferta)} </td>
                      <td> {(logisticaCosto.moneda)} </td>
                    </tr>
                  ))
                }
                </tbody>
              </table>
            </div>
          </div>
          ))
        }
        <header className='fdv-section-head'>
          <h6 className='fdv-section-title'>Equipos por cortesía</h6>
          <div className='fdv-section-actions'>
            <button onClick={(e) => props.handlePermissions(e,props.proforma.numProfVeh) && props.openEquipoAdicionales('AgregarEquipos',props.proforma) } className='btn btn-primary btn-sm active'  data-toggle='modal' data-target='#fdv-agregarBonos' data-dismiss='modal' show='#cortesAct,#cortesSec,#cortesTL' hide='#path,#bonoAct,#bonoSec,#bonoTl' fdvequipslide='0' data-permisos='ind_agregar_equipo_cortesia' >Agregar equipo por cortesía</button>
          </div>
        </header>
        {props.pedidos.map((pedido,id) =>(
        <div key={id} className='card card-plain card-lg mb-3'>

          <h6 className='h5 mb-3'>
            <span className='bold'>N° Pedido </span>
            <span>
            {pedido}
            </span>
          </h6>
          <div className='tableWrapper hidden-xs'>
            <table className='table table-hover'>
              <thead className='table-head'>
                <tr>
                  <th>Cod. Equipo</th>
                  <th>Adicional</th>
                  <th>Precio Unit.</th>
                  <th>Cantidad</th>
                  <th>Precio Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
              {
                  props.equiposCortesia.listadoAdicionales.filter(detalle => detalle.numProfVeh === props.proforma.numProfVeh &&  detalle.numPedidoVeh === pedido )
                    .map((equipo, index) => (
                      <tr key ={index}>
                        <td> {equipo.codCortesiaComercial} </td>
                        <td> {equipo.desEquipoLocalVeh} </td>
                        <td> {equipo.valPrecioVta} </td>
                        <td> {equipo.numEquipos} </td>
                        <td> {equipo.valPrecioVtaTotal} </td>
                        <td> <a className="btn btn-danger active " onClick={() => props.openModal('ModalCortesia',equipo.codCortesiaComercial,props.proforma.numProfVeh)}  >
                            <span>Inactivar</span>
                        </a>
                        </td>

                      </tr>

                    ))
                }
              </tbody>
            </table>
          </div>

        </div>
      ))}
      </section>
  </Panel>
</div>
);


class EquiposLogistica extends Component {

  constructor(props) {
    super(props);
    this.state = {
      proveedorEquposAdicionalesModalOpen:false,
      pedidos:[],
      proformaSeleccionada:'',
      equipoAdicionalLocalList:[],
      equipoAdicionalEspecialList:[],
      equipoAdicionalOtroList:[],
      dataVehiculo:[],
      proformas:[],
      facturacionListado:[],
      equiposCortesia:[],
      modalOpenvalue:false,
      codCortesiaComercial:'',
      numProfVeh:'',
      pedidosGestionCostos:[],
      /*Inicio Req 92293 ebarboza 09 08 2021 */
      codTipoMonedaProforma:props.codTipoMonedaProforma
      /*Fin Req 92293 ebarboza 09 08 2021 */
    };
  }


  componentDidMount() {

    this.loadProformas(this.props.fdvID);
 }

 fnInactivarEquipoLogistico = () => {
   this.props.loading('block');
   inactivarEquiposCortersia(this.state.codCortesiaComercial,this.props.fdvID).then((result) => {
     this.closeModal ();
   })

 }

 loadProformas = (id) => {
  this.props.loading('block');
  this.props.fetchGestionCosto(this.props.fdvID, 'L');
  this.props.fetchLogisticaCosto(this.props.fdvID).then(result => {
    this.setState({
      pedidosGestionCostos:[...new Map(this.props.logisticaCosto.listadoLogisticaCostos.map(o => [o.numPedidoVeh, o.numPedidoVeh])).values()]
    });
  });
  this.fnFetchEquiposCortesia(this.props.fdvID);
  this.props.fetchProformas(id).then((result) => {
    const idsProformas = result.payload.data.proformaExistenteList.map(row => row.numProfVeh);
    const proformas = result.payload.data.proformaExistenteList;
    this.setState({ idsProformas });
    this.setState({ proformas });
    this.props.loading('');
  }).catch((error) => {
    console.log(error);
  });
}


 fnFetchEquiposCortesia = (id) => {
   this.props.loading('block');
   this.props.fetchEquiposCortesia(id).then((result) => {
     if(result.payload.data.listadoAdicionales.length===0){
       this.setState({ equiposCortesia: {estadoTrama:'1',listadoAdicionales:[{desEquipoLocalVeh:'sdsdsd',skuSap:'12',valPrecioVtaTotal:'sdfdf'}]} });

     }else{
       this.setState({ equiposCortesia: result.payload.data });
       this.setState({pedidos:[...new Set(result.payload.data.listadoAdicionales.map(function(entry) {return entry.numPedidoVeh}))]})

     }

   }).catch((error) => {
     console.log(error);
   });;
 }



 togglePanelEstadoGestionCosto = (items) => {
   if (items === this.state.estadoGestionCosto) {
     this.setState({ estadoGestionCosto: '' });
   } else {
     this.setState({ estadoGestionCosto: items });
   }
 }

  closeAlertError = () => this.setState({proveedorEquposAdicionalesModalOpen:false });

  selectProforma = (numProfVeh) => {

    let pedidosGestionCostos = [...new Map(this.props.logisticaCosto.listadoLogisticaCostos.filter(l => l.numProfVeh===numProfVeh).map(o => [o.numPedidoVeh, o.numPedidoVeh])).values()];

    this.setState({
      pedidosGestionCostos:pedidosGestionCostos
    });

    if (this.state.proformaSeleccionada === numProfVeh) {
      this.setState({ proformaSeleccionada: '' });
    } else {
      this.setState({ proformaSeleccionada: numProfVeh });
    }

    this.props.fetchEquiposCortesia(this.props.fdvID).then((result) => {

      if(result.payload.data.listadoAdicionales.length===0){
        this.setState({ equiposCortesia: {estadoTrama:'1',listadoAdicionales:[{desEquipoLocalVeh:'sdsdsd',skuSap:'12',valPrecioVtaTotal:'sdfdf'}]} });

      }else{
        this.setState({ equiposCortesia: result.payload.data });
        this.setState({pedidos:[...new Set(result.payload.data.listadoAdicionales.filter(entry => entry.numProfVeh===this.state.proformaSeleccionada).map(function(entry) {return entry.numPedidoVeh}))]})

      }})

    this.props.fetchEquiposLogisticaDetalle(numProfVeh, '', '', 0, 0).then((result) => {

      if(result.payload.data.mensaje === "El usuario tiene acceso a la proforma"){
        this.setState({ equipoAdicionalLocalList : result.payload.data.equipoAdicionalLocalList,
          equipoAdicionalEspecialList : result.payload.data.equipoAdicionalEspecialList,
          equipoAdicionalOtroList : result.payload.data.equipoAdicionalOtroList,
          dataVehiculo : result.payload.data.dataVehiculo,
          proveedorEquposAdicionalesModalOpen:false  });

      }else{
        this.setState({proveedorEquposAdicionalesModalOpen:true,
          proformaSeleccionada: ''  })
      }



    }).catch((error) => {
      console.log(error);
    });

  }

  openEquipoAdicionales=(modal,proforma)=>{
    this.setState({
      modal:modal,
      proformaSeleccionada:proforma
    })

  }

  openModal =(modal,  codCortesiaComercial, numProfVeh) => {
    this.setState({ modal: modal,modalOpenvalue:true, codCortesiaComercial:codCortesiaComercial,numProfVeh:numProfVeh});
  }

  closeModal = () => {
      this.setState({ modal: ''});
      this.fnFetchEquiposCortesia(this.props.fdvID);
      this.props.loading('');

  }

  render() {


    return (

      <div>
        {
        this.state.proformaSeleccionada!==undefined?
        this.state.proformas.map((proforma, id) =>
        <section className='fdv-section' id='facturacionFDV' key={id} >
          {id===0?(
            <header className='fdv-section-head'>
              <h5 className='fdv-section-title'>Datos de facturación</h5>
            </header>
          ):null}
          <Proforma
            proforma={proforma}
            facturacionListado={this.state.facturacionListado}
            equipoAdicionalLocalList={this.state.equipoAdicionalLocalList}
            equipoAdicionalEspecialList={this.state.equipoAdicionalEspecialList}
            equipoAdicionalOtroList={this.state.equipoAdicionalOtroList}
            equipoAdicionalList={[...this.state.equipoAdicionalEspecialList,...this.state.equipoAdicionalOtroList,...this.state.equipoAdicionalLocalList]}
            sku={this.state.dataVehiculo.sku}
            openEquipoAdicionales={this.openEquipoAdicionales}
            equiposCortesia={this.state.equiposCortesia}
            gestionCosto={this.props.gestionCosto}
            togglePanelEstadoGestionCosto={this.togglePanelEstadoGestionCosto}
            estadoGestionCosto={this.state.estadoGestionCosto}
            pedidos={this.state.pedidos}
            proformaSeleccionada={this.state.proformaSeleccionada}
            selectProforma={this.selectProforma}
            openModal={this.openModal}
            logisticaCosto={this.props.logisticaCosto}
            handlePermissions={this.props.handlePermissions}
            pedidosGestionCostos={this.state.pedidosGestionCostos}
          />
        </section>

        ):
          this.state.proveedorEquposAdicionalesModalOpen?(
            <Alert type='alert-danger alertModal' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
              <p>La proforma no existe o no tiene permisos otro para visualizar la proforma</p>
            </Alert>):null
      }

      {
        this.props.gestionCosto && this.props.gestionCosto.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar gestionCosto</p>
          </Alert> : null
      }

      {
        this.props.equiposLogistica && this.props.equiposLogistica.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar equiposLogistica</p>
          </Alert> : null
      }

      {
        this.props.logisticaCosto && this.props.logisticaCosto.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar logisticaCosto</p>
          </Alert> : null
      }

      {this.state.modal === 'ModalCortesia' ?
        <ModalCortesia
          closeModal={this.closeModal}
          modalOpenvalue={this.state.modalOpenvalue}
          fnInactivarEquipoLogistico={this.fnInactivarEquipoLogistico}
        />:null
      }


      {this.state.modal === 'AgregarEquipos' ?
        <AgregarEquiposAdicionales
          closeModal={this.closeModal}
          proforma={this.state.proformaSeleccionada}
          fdv={this.props.fichasVenta.fichaVentaResponse[0]}
          loading={this.props.loading}
          whereRunTabOrProf={'1'}
          openAlert={this.props.openAlert}
        />:null
      }

      {
        this.props.gestionCosto && this.props.gestionCosto.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar gestionCosto</p>
          </Alert> : null
      }

      {
        this.props.equiposLogistica && this.props.equiposLogistica.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar equiposLogistica</p>
          </Alert> : null
      }

      {
        this.props.logisticaCosto && this.props.logisticaCosto.error ?
          <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
            <p>Hubo un error con el servicio de listar logisticaCosto</p>
          </Alert> : null
      }

      </div>
    )
  }
}


function mapStateToProps(state) {
  return {
    gestionCosto: state.gestionCosto,
    equiposLogistica: state.equiposLogistica,
    logisticaCosto: state.logisticaCosto
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchGestionCosto,
    fetchEquiposLogisticaDetalle,
    fetchProformas,
    fetchEquiposCortesia,
    fetchLogisticaCosto
  })(EquiposLogistica));



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/EquiposLogistica/index.js